import * as React from 'react';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Menu } from '@mui/material';
import { MenuItemT } from './WidgetCard';
import { useTranslation } from 'react-i18next';
import { capitalize } from 'helpers/helpers';

const WidgetMenuItems = ({
    menuItems,
    popoverBelow,
    closeWidgetMenu,
}: {
    menuItems: MenuItemT[];
    popoverBelow?: boolean;
    closeWidgetMenu?: () => void;
}) => {
    const { t } = useTranslation();
    const [anchorElement, setAnchorElement] =
        React.useState<HTMLElement | null>(null);

    return (
        <>
            {menuItems.map((menuItem) => [
                <>
                    <MenuItem
                        key={menuItem.name}
                        onClick={(e) => {
                            if (menuItem.hasSubMenu && e.currentTarget) {
                                setAnchorElement(e.currentTarget);
                            }
                            menuItem.action();
                            if (closeWidgetMenu) closeWidgetMenu();
                        }}
                    >
                        <ListItemIcon>{menuItem.icon}</ListItemIcon>
                        {capitalize(t(`widget.${menuItem.name}`))}
                        {menuItem.hasSubMenu && (
                            <>
                                <ListItemIcon sx={{ marginLeft: 'auto' }}>
                                    <KeyboardArrowRightIcon />
                                </ListItemIcon>
                                <Menu
                                    key="submenu-insert"
                                    anchorEl={anchorElement}
                                    open={!!anchorElement}
                                    anchorOrigin={
                                        popoverBelow
                                            ? {
                                                  vertical: 'bottom',
                                                  horizontal: 'left',
                                              }
                                            : {
                                                  vertical: 'top',
                                                  horizontal: 'right',
                                              }
                                    }
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                    sx={{ zIndex: 1500 }}
                                >
                                    <>
                                        {menuItem.subMenuItems?.map(
                                            (subMenuItem) => (
                                                <MenuItem
                                                    key={subMenuItem.name}
                                                    onClick={() =>
                                                        subMenuItem.action()
                                                    }
                                                >
                                                    <ListItemIcon>
                                                        {subMenuItem.icon}
                                                    </ListItemIcon>
                                                    {capitalize(
                                                        t(
                                                            `widget.${subMenuItem.name}`,
                                                        ),
                                                    )}
                                                </MenuItem>
                                            ),
                                        )}
                                    </>
                                </Menu>
                            </>
                        )}
                    </MenuItem>
                </>,
            ])}
        </>
    );
};

export default WidgetMenuItems;
